import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_credit_voucher',
    templateUrl: './print_credit_voucher.html',
})
export class PrintCreditVoucher implements OnInit {
    public init: boolean;

    constructor(public tournamentsService: TournamentsService) {
        SetLanguage('', '');
    }
    public ngOnInit() {
        SetLanguage('', '');
        if (this.init) {
            return;
        }
        this.init = true;
    }
}
